/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Auto_Embed_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Embedding converts a file's content into searchable vectors the assistant can look through. Only embedded files can be found by the knowledge base and refere..." |
*
* @param {Uno_Edu_Space_Auto_Embed_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_auto_embed_chip1_answer = /** @type {((inputs?: Uno_Edu_Space_Auto_Embed_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Auto_Embed_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Einbetten wandelt den Inhalt einer Datei in durchsuchbare Vektoren um, die der Assistent durchsehen kann. Nur eingebettete Dateien werden von der Wissensbasis gefunden und können mit @ referenziert werden.")
	return /** @type {LocalizedString} */ ("Embedding converts a file's content into searchable vectors the assistant can look through. Only embedded files can be found by the knowledge base and referenced with @-mentions.")
});